import { orderModel } from '../../api';
import { handoverModel } from '../../api';
import {
  ORDER_EVENTS,
  sendOrderApiEvents,
} from '../../helpers/analytics/order.analytics';

export const SET_ORDER_SHIMMER = 'SET_ORDER_SHIMMER';
export const setOrderShimmer = (value) => ({
  type: SET_ORDER_SHIMMER,
  value,
});

export const SET_ISSUE_SUBMISSION = 'SET_ISSUE_SUBMISSION';
export const setIssueSubmission = (value) => ({
  type: SET_ISSUE_SUBMISSION,
  value,
});

export const CLOSE_ACTION_VIEW = 'CLOSE_ACTION_VIEW';
export const closeActionView = (value) => ({
  type: CLOSE_ACTION_VIEW,
  value,
});

export const SET_BASIC_ORDER_INFO = 'SET_BASIC_ORDER_INFO';
export const setBasicOrderInfo = (orderInfo) => ({
  type: SET_BASIC_ORDER_INFO,
  orderInfo,
});

export const getOrderBasicInfo =
  (orderId, userId = null) =>
  (dispatch) => {
    let queryStrings = {};
    queryStrings['order_id'] = orderId;
    let orderObj = {};
    orderModel
      .getOrderBasicInfo(queryStrings)
      .then((response) => {
        if (!response || (response && response.isError === true)) return null;
        sendOrderApiEvents(
          ORDER_EVENTS.GET_ORDER_BASIC_INFO_SUCCESS,
          orderId,
          userId,
        );
        orderObj[orderId] = { ...response };
        dispatch(setBasicOrderInfo(orderObj));
        dispatch(setOrderShimmer(false));
      })
      .catch((error) => {
        sendOrderApiEvents(
          ORDER_EVENTS.GET_ORDER_BASIC_INFO_FAILURE,
          orderId,
          userId,
        );
        console.log('basic order error', error);
      });
  };

export const getRefundWarnings = (userId) => () => {
  let queryStrings = {};
  queryStrings['user_id'] = userId;
  return handoverModel
    .getRefundWarnings(queryStrings)
    .then((response) => {
      if (!response || (response && response.isError)) return null;
      sendOrderApiEvents(ORDER_EVENTS.GET_REFUND_WARNINGS_SUCCESS, '', userId);
      return response;
    })
    .catch(() => {
      sendOrderApiEvents(ORDER_EVENTS.GET_REFUND_WARNINGS_FAILURE, '', userId);
    });
};

export const addManualTag = (url, data) => () => {
  return orderModel
    .addManualTag(url, data)
    .then((response) => {
      if (!response) return;
      return response;
    })
    .catch((error) => {
      console.log('Add manual tag error', error);
    });
};
